import React, {useState, useEffect} from 'react'; // 26 Sep 2025 - added useState and useEffect
import { PlusIcon, MinusIcon } from '@heroicons/react/24/solid';
import EtUserSessionActionCard from './EtUserSessionActionCard';

//26 Sep 2025
import jstz from 'jstimezonedetect';
import moment from 'moment-timezone'; // use this instead of moment alone

// 30 Dec 2025
import { getCurrentRecurrenceLogEntry, getNextRecurrenceLogDate } from "@/utils/logUtils";

const EtGroupedActionTypeBlock = ({
  actionTypeEntries = [],
  showGroup = {},
  setShowGroup = () => {},
  actionNotes = {},
  actionProgress = {},
  showDetails = {},
  handleToggleDetails = () => {},
  handleNoteChange = () => {},
  handleProgressChange = () => {},
  handleSave = () => {},
  setSelectedAction = () => {},
  setShowEditModal = () => {},
  setSelectedActionToDelete = () => {},
  setShowDeleteModal = () => {},
  userId,
  trailId,
  sessionId,

  // actionActualValue={}, // 26 Sep 2025
  // setActionActualValue =() => {}, // 26 Sep 2025

  // 15 Sep 2025
//   getBgColor = () => {},
//   getIconClr = () => {},
//   getDaysDifference = () => {},

// 22 Dec 2025
performanceIndex,        // ✅ NEW
normalizedCollective, // 06 Jan 2026
}) => {

  // First Created - 14 Sep 2025
  // Author - Atul Pandey
  // Purpose - Render actions grouped by actionType for any hierarchy level (Vision, Mission, Goal, GoalPeriod)
  // Updated - 15 Sep 2025 - Refined with master list of props
  // Updated - 16 Sep 2025 - Action count quantification
  // Updated - 25 Sep 2025 - Refinements for recurring action progress onSave
  // Updated - 26 Sep 2025 - Refinements for recurring action progress vs regulare actionProgress for display
  // Updated - 26 Sep 2025 - actualActionValue and setActualActionValue refinements
  // Updated - 26 Sep 2025 - timezone refinements for today's logs
  // Updated - 28 Sep 2025 - refinements for handleChangeNote and handleChangeProgress
  // Updated - 22 Dec 2025 - Refined for performanceIndex={performanceIndex} and performanceSnapshot prop for EtUserSessionActionCard Comp
  // Updated - 30 Dec 2025 - Fix - for recurringLog (Non Daily) note and progress change
  // Updated - 06 Jan 2026 - normalized collective

  // 0 - Validate incoming data

  // console.log('---inside EtGroupedActionTypeBlock----')
  // console.log('actionTypeEntries', actionTypeEntries)
  // console.log('normalizedCollective in EtGroupedActionTypeBlock', normalizedCollective)

// 1 - State Variable
const [timezone, setTimezone] = useState(detectTimezone());

// 2 - Detect timezone
function detectTimezone() {
  const timezone = jstz.determine();
  return timezone ? timezone.name() : 'UTC';
}

useEffect(() => {
  const newTimezone = detectTimezone();
  if (newTimezone !== timezone) {
    setTimezone(newTimezone);
  }
}, []);


  return (
    <>
      {actionTypeEntries.map(([actionType, actions]) => {
        
        return(
        <div key={actionType} className="bg-gray-200 rounded m-1 p-1 shadow-sm">
          {/* Header toggle */}
          <div
            className="flex justify-between items-center cursor-pointer m-1 p-1"
            onClick={() =>
              setShowGroup((prev) => ({
                ...prev,
                [actionType]: !prev[actionType],
              }))
            }
          >
            <div className="flex items-center">
              {showGroup[actionType] ? (
                <MinusIcon className="h-4 w-4 text-orange-600" />
              ) : (
                <PlusIcon className="h-4 w-4 text-orange-600" />
              )}
              
              <p className="font-bold text-sm mx-2 text-gray-600">Action Type : </p>
              <p className="font-bold text-sm mx-2">{actionType}</p>
              <div className='rounded-full flex justify-center items-center h-5 w-5 border border-orange-300 bg-gray-50 m-1'>
                 <p className='text-orange-600 text-[10px]'>{actions.length}</p>
              </div>
            </div>
          </div>

          {/* Render Action Cards */}
          {showGroup[actionType] &&
            Array.isArray(actions) &&
            actions.map((action, index) => {
              // 30 Dec 2025 - changed for logDateKey
              const logDateKey = (() => {
                if (action?.actionRecurrencePattern === "OneTime") return null;

                const currentLog = getCurrentRecurrenceLogEntry(action);
                return currentLog?.logDate
                  ? moment(currentLog.logDate).format("YYYY-MM-DD")
                  : null;
              })();


              // 28 Sep 2025 - for action keys to separate one time vs. recurring actions

              // 30 Dec 2025 - commented this block
              // const logDateKey = (() => {
              //   const log = action?.recurringActionLog?.find((l) =>
              //     moment(l?.logDate).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")
              //   );
              //   return log ? moment(log?.logDate).format("YYYY-MM-DD") : null;
              // })();
              // 30 Dec 2025 - End of commented block

              const valueKey = action?.actionRecurrencePattern === "OneTime"
                ? action._id
                : `${action._id}__${logDateKey}`;

                // console.log('value key', valueKey)

              // 06 Jan 2026 - extraction of collectiveActions from normalizedCollective

              const collectiveGroup =
                normalizedCollective?.collectiveGroups?.find(
                  g => g.anchorActionId === action._id
                ) || null;

              const collectiveActions = collectiveGroup?.collectiveActions || [];
              
              return(
              <EtUserSessionActionCard
                key={action._id}
                action={action}
                actionIndex={index}
                // 22 Dec 2025
                performanceSnapshot={
                  performanceIndex?.Collective?.Action?.get(action._id) || null
                }
                collectiveActions={collectiveActions} // 06 Jan 2026
                collectiveRole={collectiveGroup?.role} // 06 Jan 2026

                showDetails={showDetails[action._id]}
                onToggleDetails={() => handleToggleDetails(action._id)}
                // actionNote={actionNotes[action._id] || ''} // 28 Sep 2025
                actionNote={actionNotes?.[valueKey] || ""} // 28 Sep 2025
                progressValue={
                  // actionProgress[action._id] !== undefined
                  actionProgress?.[valueKey] !== undefined         // 28 Sep 2025
                    // ? actionProgress[action._id]
                    ? actionProgress?.[valueKey]                    // 28 Sep 2025 
                    // : action.userActionProgress || 0 // 26 Sep 2025 - commented
                    // 26 Sep 2025 
                    : action.actionRecurrencePattern === "OneTime"
                    ? action.userActionProgress || 0
                    : (() => {

                      // 30 Dec 2025
                       const currentLog = getCurrentRecurrenceLogEntry(action);
                        return currentLog?.progress || 0;

                      // 30 Dec 2025 - commented out this entire prior block
                        // const today = new Date().toISOString().split("T")[0];
                        // const today = moment().tz(timezone).format("YYYY-MM-DD");
                        // // console.log('today', today)
                        // const log = action.recurringActionLog?.find((log) =>
                        //   log?.logDate?.startsWith(today)
                        // );
                        // return log?.progress || 0;
                      })()
                }
                // onNoteChange={(e) => handleNoteChange(e, action?._id)}
                // onProgressChange={(e) => handleProgressChange(e, action?._id)}
                //28 Sep 2025 - changes for handling recurring actions as well
                onNoteChange={(e, logDateKey) => handleNoteChange(e, action._id, logDateKey)}
                onProgressChange={(e, logDateKey) => handleProgressChange(e, action._id, logDateKey)}
                // onSave={() =>
                //   handleSave(
                //     userId,
                //     trailId,
                //     sessionId,
                //     action.actionTypeId,
                //     action._id,
                //     action.userActionName,
                //     action.userActionDesc,
                //     action.completeBy
                //   )
                // }
                //26 Sep 2025 - changes for handling recurring actions as well
                onSave={(actualValueFromCard) =>
                  handleSave({
                    action: action,
                    // noteText: actionNotes[action._id] || null, // 👈 use `null` instead of ''
                    noteText: actionNotes?.[valueKey] || null,  // 28 Sep 2025
                    // progressValue: actionProgress[action._id] !== undefined
                    progressValue: actionProgress?.[valueKey] !== undefined   // 28 Sep 2025
                      // ? actionProgress[action._id]
                      ? actionProgress?.[valueKey]         // 28 Sep 2025
                      : action.userActionProgress || 0,
                    actualValue: actualValueFromCard
                  })
                }
                onEdit={() => {
                  setSelectedAction(action);
                  setShowEditModal(true);
                }}
                onDelete={() => {
                  setSelectedActionToDelete(action);
                  setShowDeleteModal(true);
                }}
                isSelfCreated={action.actionCreatedBy === 'Self'}

                // getBgColor={getBgColor}
                // getIconClr = {getIconClr}
                // getDaysDifference = {getDaysDifference}
              />
            )})}
        </div>
      )})}
    </>
  );
};

export default EtGroupedActionTypeBlock;